export type EmailBodySource = {
    htmlBody?: string | null;
    textBody?: string | null;
};

export type EmailBodyContent = {
    content: string;
    isPlainText: boolean;
    isEmpty: boolean;
};

const hasContent = (value?: string | null): boolean =>
    typeof value === "string" && value.trim() !== "";

/**
 * Resuelve qué cuerpo mostrar de un correo recibido. Prefiere el HTML y cae al
 * texto plano cuando el correo no trae parte HTML (o viene vacía).
 */
export const pickEmailBody = (email?: EmailBodySource | null): EmailBodyContent => {
    const htmlBody = email?.htmlBody;
    const textBody = email?.textBody;

    if (hasContent(htmlBody)) {
        return { content: `${htmlBody}`, isPlainText: false, isEmpty: false };
    }

    if (hasContent(textBody)) {
        return { content: `${textBody}`, isPlainText: true, isEmpty: false };
    }

    return { content: "", isPlainText: true, isEmpty: true };
};
